import { createContext } from 'react';

/** How deep a page link's miniature is drawn: 0 on the canvas, 1 inside a miniature, where links stay static cards (P14 Ruling 12). */
export const MiniatureDepth = createContext(0);

/** Below this width on screen (css px), a page link is a static card: a live miniature that small shows nothing. */
export const MINIATURE_MIN_PX = 120;
/** The header strip of a page link (its page's name), in world px. */
export const PAGE_LINK_HEADER = 32;
/** A new page link's size, in world px. */
export const PAGE_LINK_SIZE = { w: 320, h: 200 } as const;
